module.exports = __webpack_public_path__ + "media/images/countryrect/vu-39886ba540b3a020facedaf4e14329f4.svg";